import React, { FC, Fragment } from 'react';
import { Paper, Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { PublicUserProfileFragment } from 'api';
import { UserAvatar } from 'components';
import { getFullName } from 'helpers';

import Tabs from './Tabs';
import theme from 'theme';

const styles = {
  container: {
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
  meta: {
    fontWeight: 'fontWeightRegular',
  },
  lastItem: {
    marginRight: 2,
  },
} as const;

interface IProps {
  profile: PublicUserProfileFragment;
}

const Header: FC<IProps> = React.memo(function HeaderMemo(props) {
  const { profile } = props;
  const { job_title, department_title, location_title } = profile;

  function renderDepartment() {
    return department_title ? <Fragment>- {department_title}</Fragment> : null;
  }

  function renderLocation() {
    return location_title ? <Fragment>- {location_title}</Fragment> : null;
  }

  function renderTopRow() {
    return (
      <Grid container alignItems="center">
        <Grid sx={{ marginRight: 2 }}>
          <UserAvatar link user={profile} size={70} />
        </Grid>
        <Grid xs>
          <Typography title={getFullName(profile)} color="textPrimary" variant="h4" noWrap>
            {getFullName(profile)}
          </Typography>
          <Typography
            title={job_title}
            sx={styles.meta}
            color="textSecondary"
            variant="subtitle2"
            noWrap
          >
            {job_title} {renderDepartment()} {renderLocation()}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Paper>
      <Grid sx={styles.container} container alignItems="center">
        <Grid xs>{renderTopRow()}</Grid>
      </Grid>
      <Grid container>
        <Grid>
          <Tabs profile={profile} />
        </Grid>
      </Grid>
    </Paper>
  );
});

export default Header;
